module.exports = __webpack_public_path__ + "static/img/06.6a789dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250618/06.png
// module id = J72V
// module chunks = 0